import React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent({ status = "FAILED" }) {
  return (
    <Svg
      width={14}
      height={14}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.226a5.774 5.774 0 1111.549 0A5.774 5.774 0 010 6.225zm6.352-2.31a.577.577 0 10-1.155 0 .577.577 0 001.155 0zm-.578 5.197a.577.577 0 00.578-.578v-2.31a.577.577 0 00-1.155 0v2.31a.577.577 0 00.577.578z"
        fill={status === "FAILED" ? "#FF2E00" : "#FFC000"}
      />
    </Svg>
  );
}

export default SvgComponent;
